<template>
  <div v-if="activeMappedItem">
    <v-subheader>Mapeos más cercanos</v-subheader>
    <v-item-tile
      v-for="(item, index) in similarItems"
      @click="setActiveMappedItemInputAndSave(item.mapped)"
      :key="index"
      :item="item"
      item-text="mapped"
    />
    <v-list-tile
      v-if="!similarItems.length"
      class="grey--text font-italic"
    >No existen mapeos para mostrar</v-list-tile>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import levenshtein from "js-levenshtein";
import VItemTile from "./ItemTile";

export default {
  components: {
    VItemTile
  },
  computed: {
    ...mapGetters("valueMapping", ["groupedMappedItems"]),
    ...mapState("valueMapping", ["activeMappedItem", "showingMappedValues"]),
    similarItems() {
      const value = this.showingMappedValues
        ? this.activeMappedItem.mapped.toUpperCase().trim()
        : this.activeMappedItem.value.toUpperCase().trim();
      let items = [...this.groupedMappedItems];
      /* Do not show the same mapped value */
      if (this.showingMappedValues) {
        items = items.filter(item => item.mapped !== value);
      }
      return items
        .map(item => ({ ...item, distance: levenshtein(value, item.mapped.toUpperCase().trim()) }))
        .sort((a, b) => a.distance - b.distance)
    }
  },
  methods: {
    ...mapActions("valueMapping", ["saveActiveMap"]),
    ...mapMutations("valueMapping", ["setActiveMappedItemInput"]),
    setActiveMappedItemInputAndSave(value) {
      this.setActiveMappedItemInput(value);
      if (!this.showingMappedValues) {
        this.saveActiveMap();
      }
    }
  }
};
</script>